// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__u2vqX","section-1":"styles_section-1__szBA2","content":"styles_content__JeI+o","section-2":"styles_section-2__kEeXT"};